module.exports = "0xeFabE332D31c3982B76F8630a306C960169bD5b3"


// WEBPACK FOOTER //
// ./src/contracts/Cryptogs.1.address.js